import { useState } from 'react';
import { useAppDispatch } from '@store/hooks';
import { deleteContent, getAllContents } from '@store/features/content/contentSlice';

interface UseDeleteContentResult {
  deleteContent: (contentId: string) => Promise<void>;
  isLoading: boolean;
  error: Error | null;
}

export const useDeleteContent = (): UseDeleteContentResult => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const dispatch = useAppDispatch();

  const deleteContentHandler = async (contentId: string): Promise<void> => {
    if (!contentId) {
      console.error('Content ID is undefined or empty');
      setError(new Error('Content ID is undefined or empty'));
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      await dispatch(deleteContent(contentId)).unwrap();
      dispatch(getAllContents());
    } catch (err) {
      setError(err as Error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    deleteContent: deleteContentHandler,
    isLoading,
    error,
  };
};
